const tab = document.querySelectorAll('[data-tab-target]')
const ctn = document.querySelectorAll('[data-cnt-target]')
const target = document.querySelector('[data-copy]')

const tabChange = () => {
  tab.forEach(button => {
    button.addEventListener('click', value => {
      tab.forEach(removeBtn => removeBtn.classList.remove('active'))
      ctn.forEach(removeBtn => removeBtn.classList.remove('active'))

      button.classList.add('active');

      const targetId = button.getAttribute('data-tab-target');
      document.querySelector(`[data-cnt-target="${targetId}"]`).classList.add('active');
    })
  })
}
tabChange()

const copyFunc = () => {
  target.addEventListener('click', () => {
    navigator.clipboard.writeText(target.dataset.copy);
    target.classList.add('show')
    setTimeout(() => {
      target.classList.remove('show')
    }, 2000)
  })
}
copyFunc()

const urlParams = new URLSearchParams(window.location.search);

if (urlParams.get('customer_posted').length) {
  target.classList.add('active');
  document.querySelector('.nlForm-form').classList.add('mail_customer');
}